[
  {
    "code": "ID-JW",
    "name": "Jawa"
  },
  {
    "code": "ID-KA",
    "name": "Kalimantan"
  },
  {
    "code": "ID-MA",
    "name": "Maluku"
  },
  {
    "code": "ID-NU",
    "name": "Nusa Tenggara"
  },
  {
    "code": "ID-IJ",
    "name": "Papua"
  },
  {
    "code": "ID-SL",
    "name": "Sulawesi"
  },
  {
    "code": "ID-SM",
    "name": "Sumatera"
  }
]